import { FC } from 'react';

import Box from 'app/components/v2/components/Box';
import IconButton from 'app/components/v2/components/IconButton';
import { semanticStatusColorLookup, StatusColor } from 'app/components/v2/components/Pill/utils';
import Paragraph from 'app/components/v2/components/Text/Paragraph';

// Local Typings
interface Props {
  alertMessage?: string;
  isActive: boolean;
  onClose: () => void;
  statusColor?: StatusColor;
}

// Local Variables
const bannerHeight = '50px';

// Component Definition
const SystemAlert: FC<Props> = props => {
  if (!props.isActive || !props.alertMessage) {
    return null;
  }

  return (
    <Box
      backgroundColor={semanticStatusColorLookup[props.statusColor ?? 'red']}
      height={bannerHeight}
      overflow="hidden"
    >
      <Box
        alignItems="center"
        display="flex"
        fullHeight
        gap={4}
        justifyContent="space-between"
        paddingX={6}
      >
        <Paragraph fontColor="status_text">
          {props.alertMessage}
        </Paragraph>

        <IconButton
          circle
          iconName="close"
          onClick={props.onClose}
        />
      </Box>
    </Box>
  );
};

export default SystemAlert;
